import { isApiError } from './errors';

/** `details.backend.fields` as a string map; `{}` when absent. Works for any code. */
export function backendFields(error: unknown): Record<string, string> {
  const backend = isApiError(error) ? error.details.backend : undefined;
  if (typeof backend !== 'object' || backend === null) return {};
  const fields = backend.fields;
  if (typeof fields !== 'object' || fields === null) return {};
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(fields)) {
    if (typeof value === 'string' && value.length > 0) out[key] = value;
  }
  return out;
}

/** `details.backend.<key>` as a finite number, else null. */
export function backendNumber(error: unknown, key: string): number | null {
  const backend = isApiError(error) ? error.details.backend : undefined;
  if (typeof backend !== 'object' || backend === null) return null;
  const value = backend[key];
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
